const CACHE_KEY = "cached_logo";

const logoStorage = {
	get(logoPath: string): string | null {
		try {
			const cached = localStorage.getItem(CACHE_KEY);
			if (!cached) return null;
			const parsedCache = JSON.parse(cached);
			return parsedCache.logoPath === logoPath ? parsedCache.dataUrl : null;
		} catch {
			return null;
		}
	},

	set(logoPath: string, dataUrl: string): void {
		try {
			localStorage.setItem(CACHE_KEY, JSON.stringify({ logoPath, dataUrl }));
		} catch {}
	},
};

export default logoStorage;
